// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-title[data-v-04eb30bd] {\n  font-weight: 500;\n  font-size: 1.85rem;\n}\n.modal-dialog[data-v-04eb30bd] {\n  width: 600px;\n  max-width: 600px;\n}\n.modal-content[data-v-04eb30bd] {\n  border-radius: 20px;\n  box-shadow: 0px 4px 40px 0px rgba(204, 213, 212, 0.3);\n}\n.btn[data-v-04eb30bd] {\n  padding: 0.7rem 2.5rem;\n}\n.input-box[data-v-04eb30bd] {\n  width: 47.5%;\n}\n", ""]);
// Exports
module.exports = exports;
